import * as parsedAddressActions from '../actions/parsed-address.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { ParsedAddress } from 'app/components/map/map.models';

export interface State {
  isReady: boolean;
  parsedAddress: ParsedAddress;
}

export const initialState: State = {
  isReady: false,
  parsedAddress: null,
};

const featureReducer = createReducer(
  initialState,
  on(parsedAddressActions.updateParsedAddress, (state, { parsedAddress }) => ({
    ...state,
    parsedAddress,
  })),
  on(parsedAddressActions.resetParsedAddress, () => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
